import {Component} from '@angular/core';
import {ResetPasswordViewModel} from "@app/presentation/pages/reset-password/reset-password.view-model";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {routesNames} from "@app/app-routing.module";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  resetPasswordForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });
  routeNames = routesNames;

  constructor(
      public resetPasswordViewModel: ResetPasswordViewModel,
      private popupDispatcher: PopupDispatcher,
  ) {
    this.popupDispatcher.setNotifier(resetPasswordViewModel.notifier);
  }

  onSubmit(): void {
    this.resetPasswordViewModel.resetPassword(this.resetPasswordForm.controls.email.value)
  }
}
